export default "__VITE_ASSET__807108f2__"